import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
const PREVIEW_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/hidUKig3cyuVWECuSpgpxb/ChatGPT_Image_15_jun_2026,_09_45_19.png',
  alt: 'Módulo 1 — Fundamentos: Los Tres Pilares de la Carta Natal'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/v2VGKwYpDuV7vxDGpFUTqH/ChatGPT_Image_15_jun_2026,_09_45_37.png',
  alt: 'Módulo 2 — Los 12 Signos del Zodíaco en Profundidad'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ax74V4iQJ2QftWz9Hpo6mg/ChatGPT_Image_15_jun_2026,_09_45_49.png',
  alt: 'Módulo 3 — Los Planetas: El Sol y su Influencia'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/d3udFaUaxtTUUT3pXqx8Pp/ChatGPT_Image_15_jun_2026,_09_46_02.png',
  alt: 'Módulo 4 — Las 12 Casas Astrológicas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/x5XRRo3LjkCsJU7bYVcyrU/ChatGPT_Image_15_jun_2026,_09_46_12.png',
  alt: 'Módulo 5 — Los Aspectos Astrológicos'
}];
export function PreviewCarousel() {
  const [ref, vis] = useReveal();
  const [current, setCurrent] = useState(0);
  const goTo = (index: number) => {
    setCurrent(index);
  };
  const prev = () => {
    setCurrent(c => c === 0 ? PREVIEW_IMAGES.length - 1 : c - 1);
  };
  const next = () => {
    setCurrent(c => c === PREVIEW_IMAGES.length - 1 ? 0 : c + 1);
  };
  return <section className="bg-[#0a0e1f] py-5 md:py-10 px-4 sm:px-6 border-t border-[#ffffff]/5" data-id="element-126">
      <div className="container mx-auto max-w-4xl" data-id="element-127">
        <div ref={ref} className={`reveal text-center mb-10 ${vis ? 'is-visible' : ''}`} data-id="element-128">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-[#f5f1e6]" data-id="element-129">
            👀 Mirá por dentro
          </h2>
          <p className="text-[#cbd0e0] text-lg font-medium" data-id="element-130">
            Páginas reales del material que vas a recibir
          </p>
        </div>

        <div className="relative" data-id="element-131">
          {/* Main Image — fixed height to reserve layout space and avoid scroll shift */}
          <div className="relative overflow-hidden rounded-xl border border-[#d4af37]/20 bg-[#1a1f3d] shadow-lg flex items-center justify-center h-[58vh] sm:h-[64vh] md:h-[70vh]" data-id="element-132">
            <img src={PREVIEW_IMAGES[current].src} alt={PREVIEW_IMAGES[current].alt} className="max-w-full max-h-full object-contain mx-auto" data-id="element-133" />

            {/* Navigation Arrows */}
            <button onClick={prev} className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#1a1f3d]/80 border border-[#d4af37]/30 flex items-center justify-center text-[#d4af37] hover:bg-[#d4af37] hover:text-[#0a0e1f] hover:border-[#d4af37] transition-all z-10 shadow-sm" aria-label="Anterior" data-id="element-134">
              ‹
            </button>
            <button onClick={next} className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#1a1f3d]/80 border border-[#d4af37]/30 flex items-center justify-center text-[#d4af37] hover:bg-[#d4af37] hover:text-[#0a0e1f] hover:border-[#d4af37] transition-all z-10 shadow-sm" aria-label="Siguiente" data-id="element-135">
              ›
            </button>
          </div>

          {/* Caption */}
          <p className="text-center text-[#cbd0e0] text-sm mt-4 font-bold" data-id="element-136">
            {PREVIEW_IMAGES[current].alt}
          </p>

          {/* Thumbnails */}
          <div className="flex justify-center gap-2 mt-4 overflow-x-auto pb-2" data-id="element-137">
            {PREVIEW_IMAGES.map((img, i) => <button key={i} onClick={() => goTo(i)} className={`flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden border-2 transition-all ${i === current ? 'border-[#d4af37] shadow-md' : 'border-[#ffffff]/10 opacity-60 hover:opacity-100'}`} data-id="element-138">
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-139" />
              </button>)}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-3" data-id="element-140">
            {PREVIEW_IMAGES.map((_, i) => <button key={i} onClick={() => goTo(i)} className={`w-2 h-2 rounded-full transition-all ${i === current ? 'bg-[#d4af37] w-6' : 'bg-[#ffffff]/20'}`} aria-label={`Ir a imagen ${i + 1}`} data-id="element-141" />)}
          </div>
        </div>
      </div>
    </section>;
}